/**
 * Styled Components - Created by david on 12/02/18.
 */
import styled, { keyframes } from 'styled-components'
import Icon from 'antd/lib/icon'
import Spin from 'antd/lib/spin'
import { GRAY_DARK, RED, TRANSPARENT, WHITE } from '../../theme/colors'

interface StyleProps {
  withBorder?: boolean
  withMargin?: boolean
  selectProduct?: boolean
  fromTop?: boolean
  isSelected?: boolean
  fitContainer?: boolean
  hide?: boolean
}

type StyledProps = {
  backgroundColor?: string
  showTooltips?: boolean
  isHovered?: boolean
  archived?: boolean
  withBorder?: boolean
  withMargin?: boolean
  selected?: boolean
}

export const Container = styled.section`
  margin: ${({ withMargin }: StyleProps) => (withMargin ? '0px 16px' : '0')};
  margin-bottom: ${({ selectProduct }: StyleProps) => (selectProduct ? '16px' : '0')};
  width: ${({ fitContainer }: StyleProps) => (fitContainer ? '100%' : '220px')};
  border: 3px solid;
  border-radius: 6px;
  border-color: ${({ isSelected }: StyleProps) => (isSelected ? RED : TRANSPARENT)};
  ${({ hide }: StyleProps) => hide ? `
    display: flex;
    width: fit-content;
  ` : ''}
  transition: all .45s;
  @media (min-width: 320px) and (max-width: 480px) {
    margin: 0 auto;
    width: auto;
  }
`

export const NotificationsBadge = styled.div`
  position: relative;
  z-index: 3;
  float: right;
  margin-top: -17px;
  top: 17px;
  background: ${RED};
  width: 19px;
  text-align: center;
  color: white;
  border-radius: 50%;
  font-size: 11px;
  height: 19px;
  align-items: center;
  display: flex;
  justify-content: center;
`

export const Text = styled.div`
  color: ${WHITE};
`

export const BuyNow = styled.div`
  font-size: 10px;
  border: 1px solid #7dc153;
  background: #7dc153;
  color: white;
  padding: 2px 4px;
  margin-left: 2px;
  letter-spacing: 1px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 4px;
  border-radius: 4px;
  max-width: 82px;
  &:hover {
    background: white;
    color: #7dc153;
  }
`

export const BuyNowCart = styled.div`
  font-size: 10px;
  border: 1px solid #7dc153;
  color: white;
  background: #7dc153;
  padding: 4px;
  margin-left: 2px;
  letter-spacing: 1px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 4px;
  border-radius: 4px;
  width: 100%;
  &:hover {
    background: white;
    color: #7dc153;
  }
  @media (max-width: 698px) {
    font-size: 12px;
    margin: 0 auto;
  }
`

export const BuyLoader = styled(Spin)`
  align-items: center;
  justify-content: center;
  display: flex;
  margin-left: 16px;
  margin-top: 4px;
`

export const ImageContainer = styled.div`
  user-select: none;
  cursor: pointer;
  background-color: #f1f4f5;
  height: 214.13px;
  width: ${({ fitContainer }: StyleProps) => (fitContainer ? '100%' : '220px')};
  padding: 10px;
  text-align: center;
`

export const Image = styled.img`
  user-select: none;
  height: 200.29px;
  width: 180.44px;
`

export const ImageTop = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  justify-content: space-between;
`
export const TopContainer = styled.div`
  height: 35.04px;
  width: 36px;
  background-color: #e61737;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const TopText = styled.div`
  color: #ffffff;
  font-size: 8px;
  font-weight: 500;
  line-height: 11px;
  text-align: center;
  text-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.24);
`

export const Footer = styled.div`
  padding: 4px;
  font-family: Avenir;
  ${({ hide }: StyleProps) => !hide ? `
    padding-top: 0px;
  ` : `
    padding-top: 8px;
    padding-left: 10px;
  `}
`

export const QuickView = styled.img``

export const Type = styled.div`
  color: black;
  font-size: 14px;
  line-height: 19px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: ${({ fitContainer }: StyleProps) => (fitContainer ? '100%' : '212px')};
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  ${({ hide }: StyleProps) => hide ? `
    width: 100%;
    font-size: 12px;
  ` : ''}
  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
  }
`
export const MenIcon = styled(Icon)`
  color: #2196f3;
`
export const WomenIcon = styled(Icon)`
  color: deeppink;
`

export const GendersContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
`

export const YouthLabel = styled.div`
  font-size: 8px;
  color: #549c8c;
  font-family: Avenir;
  font-weight: bold;
  margin-left: 3px;
  text-align: right;
  line-height: 1.5;
  max-width: 38px;
`

export const Description = styled.div`
  user-select: none;
  color: black;
  font-size: 12px;
  font-weight: bold;
  line-height: 16px;
  padding: 2px 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: fit-content;
  display: flex;
  justify-content: space-between;
  width: 100%;
  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
  }
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  user-select: none;

  @media (min-width: 320px) and (max-width: 425px) {
    flex-wrap: wrap;
  }
`

export const ProductName = styled.div``

export const Label = styled.div`
  color: black;
  display: flex;
  font-size: 12px;
  line-height: 16px;
  user-select: none;
  ${({ fromTop }: StyleProps) => fromTop ? `
    font-size: 10px;
  ` : ''}
`
export const ImgIcon = styled.img`
  height: 15px;
  margin-right: 5px;
  width: 15px;
  border-radius: 50%;
  ${({ withBorder }: StyleProps) => (withBorder ? 'border: 1px solid' : '')};
`
export const Price = styled.div`
  user-select: none;
  color: black;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  ${({ fromTop }: StyleProps) => fromTop ? `
    font-size: 11px;
    text-align: right;
  ` : ''}
`

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

export const Arrows = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  top: 165px;
  width: 200px;
  justify-content: space-between;
  animation: ${fadeIn} 0.6s linear;
`

export const Arrow = styled.img`
  user-select: none;
`

export const RetailColors = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`

export const ColorOption = styled.div`
  width: fit-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 18px;
  padding: 0px 9px;
  margin-right: 7px;
  transition: all .25s;
  margin-bottom: 9px;
`

interface DivProps {
  secondary?: boolean
}

export const ColorName = styled.div`
  z-index: 2;
  color: #b0b0b0;
  font-size: 10px;
  mix-blend-mode: difference;
  white-space: nowrap;
  ${({ secondary }: DivProps) => secondary ? `
    color: ${WHITE};
    mix-blend-mode: unset;
  ` : ''};
`

export const ProductAvailableColor = styled.img`
  position: absolute;
  z-index: 1;
  object-fit: cover;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 25px;
  transition: all .25s;
  border: ${({ selected, withBorder }: StyledProps) =>
    selected
      ? `2px solid #ff99a9`
      : (withBorder ? `1px solid ${GRAY_DARK}` : 'none')};
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ProductThumbnailRecommended/styledComponents.tsx